import * as api from "../api";

export const signIn = (formData, navigate) => async (dispatch) => {
  try {
    const { data } = await api.signIn(formData);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const extendSession = async (sessionTime) => {
  try {
    await api.extendSession(sessionTime);
  } catch (error) {
    return error.response;
  }
};
export const logout = (navigate) => async (dispatch) => {
  try {
    await api.logout();
    dispatch({ type: "LOGOUT" });
    navigate("/login", { state: { message: "You have been logout!" } });
  } catch (error) {
    return error.response;
  }
};
export const checkIfAdmin = async () => {
  try {
    const { data } = await api.checkIfAdmin();
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const getSession = async () => {
  try {
    const { data } = await api.getSession();
    return data;
  } catch (error) {
    return { requestError: error.response.data };
  }
};
export const authenticated = async () => {
  try {
    const { data } = await api.authenticated();
    return data;
  } catch (error) {
    return { alreadyLogged: false };
  }
};
export const getUser = async () => {
  try {
    const { data } = await api.getUser();
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const editProfile = async (dataEdit) => {
  try {
    const { data } = await api.editProfile(dataEdit);

    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const setDishTimeServe = async (time) => {
  try {
    const { data } = await api.setDishTimeServe(time);
    return data;
  } catch (error) {
    return error.response.data;
  }
};
export const setAnnouncement = async (data) => {
  try {
    await api.setAnnouncement(data);
  } catch (error) {}
};

export const getAnnouncement = async (userId) => {
  try {
    const { data } = await api.getAnnouncement(userId);
    return data;
  } catch (error) {}
};

export const fetchAllUser = async () => {
  try {
    const { data } = await api.fetchAllUser();
    return data;
  } catch (error) {}
};
export const setUnreadMessage = async (data) => {
  try {
    await api.setUnreadMessage(data);
  } catch (error) {}
};

export const notifyRead = async (data) => {
  try {
    await api.notifyRead(data);
  } catch (error) {}
};
